import { Component, input } from '@angular/core';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import L, { Icon, icon, latLng, marker, tileLayer } from 'leaflet';

@Component({
    selector: 'app-map',
    imports: [LeafletModule],
    host: {
        class: 'block size-full aspect-[19/9] max-h-[60vh] container mx-auto',
    },
    templateUrl: './map.component.html',
})
export class MapComponent {
    data = input.required<MapData>();
    options: L.MapOptions = {};

    ngOnInit(): void {
        const latLngObj = {
            lat: parseFloat(this.data().latitude),
            lng: parseFloat(this.data().longitude),
        };

        this.options = {
            layers: [
                tileLayer(
                    'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                    {
                        maxZoom: 18,
                        attribution:
                            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
                    },
                ),
                marker([latLngObj.lat, latLngObj.lng], {
                    icon: icon({
                        ...Icon.Default.prototype.options,
                        iconUrl: 'assets/marker-icon.png',
                        iconRetinaUrl: 'assets/marker-icon-2x.png',
                        shadowUrl: 'assets/marker-shadow.png',
                    }),
                }),
            ],
            zoom: 14,
            center: latLng(latLngObj.lat, latLngObj.lng),
        };
    }
}

export type MapData = {
    latitude: string;
    longitude: string;
};
